import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { CartMaster } from '../model/CartMaster.model';
import { CourseMaster } from '../model/CourseMaster.model';
import { LectureMaster } from '../model/LectureMaster.model';
import { StudentMaster } from '../model/StudentMaster.model';
import { AuthService } from '../service/auth.service';
import { MainserviceService } from '../service/mainservice.service';
import { MessageService } from 'primeng/api';
import { CourseHistory } from '../model/CourseHistory.model';
import { TrainerMaster } from '../model/TrainerMaster.model';
import Player from '@vimeo/player';
import { DocumentMaster } from '../model/DocumentMaster.model';
import { CourseLectureMaster } from '../model/CourseLectureMaster.model';
import { DomSanitizer } from '@angular/platform-browser';
import { EnrollCourseMaster } from '../model/EnrollCourseMaster.model';


declare var require: any
const FileSaver = require('file-saver');
@Component({
  selector: 'app-course-details',
  templateUrl: './course-details.component.html',
  styleUrls: ['./course-details.component.scss']
})
export class CourseDetailsComponent implements OnInit {
  courseMasterTemp: CourseMaster = new CourseMaster();
  courseMaster: CourseMaster = new CourseMaster();
  tempCourse: CourseMaster[] = [];
  pageSize: number = 5;
  pageNumber: number = 0;
  showbtn: boolean = true;
  courseHistory: CourseHistory = new CourseHistory();
  courseTemp: CourseMaster = new CourseMaster();
  showEmi: boolean = false;
  valueEmi: boolean = false;
  documentMasterTemp1: DocumentMaster = new DocumentMaster();
  documentMasterTemp2: DocumentMaster = new DocumentMaster();
  showbracket: boolean = false;

  player;
  showDialogVideo: boolean = false;
  showVideo: boolean = false;

  trainerMasterTemp: TrainerMaster = new TrainerMaster();
  valueTrainer: boolean = false;
  showDialogTrainer: boolean = false;

  imagecarousel: any;
  activeState: boolean[] = [true, false, false];
  gallerycarousel: any;
  cartMaster: CartMaster = new CartMaster();
  student: StudentMaster = new StudentMaster();
  studentMaster: StudentMaster = new StudentMaster();
  courseMasterList: CourseMaster[] = [];
  showDialog: boolean = false;
  value: boolean = false;
  totalRecords: number = 0;

  courselistTemp: CourseMaster = new CourseMaster();



  constructor(private mainService: MainserviceService, private authService: AuthService, private router: Router, private messageService: MessageService, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.courseMasterTemp = this.authService.getcourseMasterSession();
    this.student = this.authService.getUserSession();
    this.getCourseMasterList();



    this.getCourseMasterById();
    this.saveCourseHistory();

    this.gallerycarousel = {
      loop: false,
      autoplay: false,
      margin: 20,
      mouseDrag: false,
      touchDrag: false,
      pullDrag: false,
      dots: true,
      items: 4,
      navSpeed: 1000,
      navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
      responsive: {
        0: {
          items: 1
        },
        400: {
          items: 2
        },
        740: {
          items: 3
        },
        940: {
          items: 4
        }


      },
      nav: true
    }


    this.imagecarousel = {
      loop: false,
      autoplay: false,
      margin: 1000,
      mouseDrag: false,
      touchDrag: false,
      pullDrag: false,
      dots: true,
      items: 1,
      navSpeed: 500,
      navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
      responsive: {
        0: {
          items: 1
        },
        400: {
          items: 2
        },
        740: {
          items: 3
        },
        940: {
          items: 4
        }


      },
      nav: true
    }


  }

  toggle(index: number) {
    this.activeState[index] = !this.activeState[index];
  }

  saveCart() {

    this.studentMaster.studentMasterId = this.student.studentMasterId;
    this.courseMaster.courseMasterId = this.courseMasterTemp.courseMasterId

    this.cartMaster.courseMaster = this.courseMaster;
    this.cartMaster.studentMaster = this.studentMaster;



    this.mainService.saveCartMaster(this.cartMaster).subscribe(data => {
      this.cartMaster = data;
      this.messageService.add({ severity: 'success', summary: 'Successfully', detail: 'Added to Cart' });


    }, (err: HttpErrorResponse) => {
      if (err.status === 200) {
        this.messageService.add({ severity: 'success', summary: 'Successfully', detail: 'Added to Cart' });
        let jsonString = err.error.text;
        jsonString = jsonString.substr(0, jsonString.indexOf('{"timestamp"'));
        // this.packageServiceList = JSON.parse(jsonString);

      }


    })


  }


  getCourseMasterById() {
    let courseMasterVar = new CourseMaster();
    courseMasterVar.courseMasterId = this.courseMasterTemp.courseMasterId;

    if(this.student != null &&  this.student.studentMasterId != null){
      courseMasterVar.studentMasterId = this.student.studentMasterId;
    }

    this.mainService.getCourseMasterById(courseMasterVar).subscribe(data => {
      this.courseMaster = data;
      this.showbracket = true;




    }, (err: HttpErrorResponse) => {
      if (err.status === 200) {
        let jsonString = err.error.text;
        jsonString = jsonString.substr(0, jsonString.indexOf('{"timestamp"'));
        // this.packageServiceList = JSON.parse(jsonString);

      }


    })


  }

  resumeCourse(){

    let enrollCourseMasterTemp = new EnrollCourseMaster();
    enrollCourseMasterTemp.enrollCourseMasterId = this.courseMaster.enrollCourseMasterId;
    this.authService.setEnrollCourseMasterSession(enrollCourseMasterTemp);
    this.router.navigateByUrl('/mycourse-details');

  }


  buyCourse() {
    this.courseMaster.courseLectureMasterList = [];
    this.tempCourse.push(this.courseMaster);
    this.authService.setcourseListSession(this.tempCourse);



    this.router.navigateByUrl('/payment-confirmation');
  }




  getCourseMasterList() {

    this.courselistTemp.isMasterCourse = false;

    this.courselistTemp.pageNumber = this.courselistTemp.pageNumber
      ? this.courselistTemp.pageNumber
      : this.pageNumber;
    this.courselistTemp.pageSize = this.courselistTemp.pageSize
      ? this.courselistTemp.pageSize
      : this.pageSize;

    this.mainService.getCourseMasterList(this.courselistTemp).subscribe(
      (data) => {
        this.courseMasterList = data;
        this.getCourseMasterListLength();




      },
      (error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
            //   this.spinnerService.hide();
            return JSON.parse(jsonString);
          } else {
            this.authService.showMessage('error', 'Something went wrong', '');
            //  this.spinnerService.hide();
          }
        }
      }
    );
  }



  saveCourseHistory() {


    this.courseHistory.user = this.student.user
    this.courseHistory.user.id = this.student.studentMasterId;
    this.courseHistory.courseMaster = this.courseMasterTemp
    this.courseHistory.courseMaster.courseMasterId = this.courseMasterTemp.courseMasterId;



    this.mainService.saveCourseHistory(this.courseHistory).subscribe(
      (data) => {
        this.courseHistory = data;





      },
      (error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
            //   this.spinnerService.hide();
            return JSON.parse(jsonString);
          } else {
            this.authService.showMessage('error', 'Something went wrong', '');
            //  this.spinnerService.hide();
          }
        }
      }
    );
  }


  navigateTrainer(trainerMaster: TrainerMaster) {
    this.authService.setTrainerSession(trainerMaster);
    this.router.navigateByUrl('/trainer-profile')
  }

  pleaseLogin() {
    this.messageService.add({ severity: 'error', summary: 'Please Login', detail: 'to continue' });
  }



  viewDialogTrainer(trainerMaster: TrainerMaster) {
    this.trainerMasterTemp = new TrainerMaster()
    this.trainerMasterTemp = trainerMaster;
    this.showDialogTrainer = true;

  }


  incrementPage() {

    this.courselistTemp.pageNumber = this.courselistTemp.pageNumber
    this.courselistTemp.pageSize = this.courselistTemp.pageSize + 5;









    this.getCourseMasterList();


    if (this.courselistTemp.pageSize >= this.totalRecords) {

      this.showbtn = false;
    }
  }


  getCourseMasterListLength() {



    this.courselistTemp.isMasterCourse = false;


    this.mainService.getCourseMasterListLength(this.courselistTemp).subscribe(data => {
      this.totalRecords = data;


    }, (err: HttpErrorResponse) => {
      if (err.status === 200) {
        let jsonString = err.error.text;
        jsonString = jsonString.substr(0, jsonString.indexOf('{"timestamp"'));
        this.courselistTemp = JSON.parse(jsonString);

      }


    })
  }


  // viewChapter(lectureMaster:LectureMaster){
  //   this.authService.setlectureMasterSession(lectureMaster);
  //   let user=this.authService.getUserSession();
  //   if(user!=null && user!=undefined && user.studentMasterId!=undefined){
  //     this.router.navigateByUrl('/chapter-details');
  //   }else{
  //   this.router.navigateByUrl('/login');
  //   }
  // }



  viewEmi() {


    this.showEmi = true;


  }


  viewDialog() {




    this.showDialog = true;




  }


  downloadFile(fileUrl: string) {

    if (fileUrl === null) {
      this.messageService.add({ severity: 'error', summary: 'No Brochure', detail: 'available' });
      return;
    }

    var fileUrlSplit = fileUrl.split("/");

    FileSaver.saveAs(fileUrl, fileUrlSplit[fileUrlSplit.length - 1]);

  }


  downloadBrochure() {

    if (this.courseMaster.courseBrochure && this.courseMaster.courseBrochure.filePath != null) {
      this.downloadFile(this.courseMaster.courseBrochure.filePath);
    } else {
      this.messageService.add({ severity: 'error', summary: 'No Brochure', detail: 'available' });
    }
  }

  viewCourse(courseMaster: CourseMaster) {
    this.authService.setcourseMasterSession(courseMaster);
    window.location.reload();

    this.router.navigateByUrl('/course-details');

  }



  viewDialogVideo(courseLecture: CourseLectureMaster) {
    this.documentMasterTemp1 = courseLecture.lectureMaster.demoVideo;
    if (this.documentMasterTemp1.linkId != null && this.documentMasterTemp1.linkId != undefined) {
      this.documentMasterTemp1.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.documentMasterTemp1.link);
    }
    this.showDialogVideo = true;

    setTimeout(() => {
      this.initPlayer1();
      this.setVideo1(this.documentMasterTemp1.linkId);

      this.playVideo1();

    }, 500);
  }

  public initPlayer1() {
    this.player = new Player('video_iframe', {});
    // this.updateVideoCompleted();
  }

  setVideo1(videoId: any) {

    // this.destroyPlayer();
    // this.initPlayer();


    this.player.loadVideo(videoId).then(function (id) {

    });

  }

  playVideo1() {
    setTimeout(() => {
      this.player.play().then(function () {

      });
    }, 1000);

  }





  closeVideo() {
    this.showDialogVideo = false;
  }


  videoDisplay() {


    this.documentMasterTemp2 = this.courseMaster.courseBannerVideo;
    if (this.documentMasterTemp2.linkId != null && this.documentMasterTemp2.linkId != undefined) {
      this.documentMasterTemp2.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.documentMasterTemp2.link);
    }

    this.showVideo = true;


    setTimeout(() => {
      this.initPlayer();
      this.setVideo(this.documentMasterTemp2.linkId);

      this.playVideo();

    }, 500);


  }

  public initPlayer() {
    this.player = new Player('video_iframe', {});
    // this.updateVideoCompleted();
  }

  setVideo(videoId: any) {

    // this.destroyPlayer();
    // this.initPlayer();


    this.player.loadVideo(videoId).then(function (id) {

    });

  }

  playVideo() {
    setTimeout(() => {
      this.player.play().then(function () {

      });
    }, 1000);

  }

  closeVideo2() {
    this.showVideo = false;
  }




}
